import useSWR from 'swr';
import { fetchHomeRecommendations, HomeRecommendationsResponse } from '@services/api/home-recommendations';


// Constants
// ********************************************
export const HOME_RECOMMENDATIONS_DEFAULT_LIMIT = 3;
const SWR_KEY = '/v1/jobs/recommendations/home';


/**
 * @description Fetches the personalised home job recommendations for the current user.
 *
 * The SWR key is shared across consumers, so multiple components calling this hook with
 * the same `(locale, limit)` trigger a single request (SWR dedupes by key). Pass
 * `enabled = false` (e.g. for unauthenticated users) to skip the fetch entirely.
 */
export const useHomeRecommendations = (
  locale: Locale,
  limit = HOME_RECOMMENDATIONS_DEFAULT_LIMIT,
  enabled = true,
) => {
  const { data, isLoading } = useSWR<HomeRecommendationsResponse>(
    enabled ? [SWR_KEY, locale, limit] : null,
    () => fetchHomeRecommendations(limit, locale),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      errorRetryCount: 0,
    },
  );

  const items = data?.items ?? [];

  return {
    items,
    isLoading,
    hasItems: items.length > 0,
  };
};
